/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import ManSVGR from '../../../../assets/svgr/ManSVGR';
import ManMobileSVGR from '../../../../assets/svgr/ManMobileSVGR';
import MoneySVGR from '../../../../assets/svgr/MoneySVGR';
import MoneyMobileSVGR from '../../../../assets/svgr/MoneyMobileSVGR';
import './styles.scss';
import CalculatorLogoSVGR from '../../../../assets/svgr/CalculatorLogoSVGR';
import CalculatorMobileLogoSVGR from '../../../../assets/svgr/CalculatorMobileLogoSVGR';

const PlanForLifes = ({ calculateRef }) => {
  const mobileScreen = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const mobileScreenSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Container>
      <Grid container className='plan-for-lifes' justifyContent='center' mb={{ xs: 0, md: 5 }} mt={{ xs: 1, md: 5 }}>
        <Grid item display='flex' justifyContent='center' xs={12} mb={{ xs: 5, sm: 10 }} mt={{ xs: 5, md: 10 }}>
          <p className='title-plan-for-lifes'>
            Plan for life&apos;s uncontrollable events with these steps:
          </p>
        </Grid>
        <Grid item xs={12} sm={4}>
          {mobileScreen ? <Box ml={-3}><CalculatorMobileLogoSVGR /></Box> : <Box ml={-4.5}><CalculatorLogoSVGR /></Box>}
          <p className='subtitle-plan-for-lifes'>
            Calculate your lifetime
            {!mobileScreenSM && <br />}
            {' '}
            benefits and
            {mobileScreenSM && <br />}
            {' '}
            potential
            {!mobileScreenSM && <br />}
            {' '}
            reduction with the
            {!mobileScreenSM && <br />}
            <span className='subtitle-plan-for-lifes-bold-color link' onClick={() => calculateRef.current.scrollIntoView()} tabIndex={-1}>
              {' '}
              Lifetime
              {mobileScreenSM && <br />}
              {' '}
              Social Security
              {!mobileScreenSM && <br />}
              {' '}
              Benefit Estimator
            </span>
          </p>
        </Grid>
        <Grid item xs={12} sm={4}>
          {mobileScreen ? <MoneyMobileSVGR /> : <MoneySVGR />}
          <p className='subtitle-plan-for-lifes'>
            Explore solutions to help
            {' '}
            {!mobileScreenSM && <br />}
            {' '}
            offset a
            {mobileScreenSM && <br />}
            {' '}
            potential loss
          </p>
        </Grid>
        <Grid item xs={12} sm={4}>
          {mobileScreen ? <ManMobileSVGR /> : <ManSVGR />}
          <p className='subtitle-plan-for-lifes'>
            Contact your financial professional
          </p>
        </Grid>
      </Grid>
    </Container>
  );
};

PlanForLifes.propTypes = {
  calculateRef: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.shape()]),
};

PlanForLifes.defaultProps = {
  calculateRef: undefined,
};
export default PlanForLifes;
